import { render, staticRenderFns } from "./acus.vue?vue&type=template&id=8f0905b4&scoped=true&"
import script from "./acus.vue?vue&type=script&lang=js&"
export * from "./acus.vue?vue&type=script&lang=js&"
import style0 from "./acus.vue?vue&type=style&index=0&id=8f0905b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0905b4",
  null
  
)

export default component.exports